// src/components/StreamVideo.jsx
import React from "react";
import { streamIframeUrl } from "../videos/streamVideos";

export default function StreamVideo({ videoId, title = "Video", className = "" }) {
  if (!videoId) return null;

  return (
    <div className={`w-full ${className}`}>
      <div
        className="relative w-full overflow-hidden rounded-2xl bg-black"
        style={{ paddingTop: "56.25%" }} // 16:9
      >
        <iframe
          className="absolute inset-0 h-full w-full"
          src={streamIframeUrl(videoId)}
          title={title}
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
        />
      </div>
    </div>
  );
}
